<template>
    <div>
        <h4 class="p-2">Datos fiscales</h4>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off" @input="getClear('inst')">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar
                    </label>
                    <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" autocomplete="off" @input="getClear('ciclo')">
                        <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                            Requerido
                        </template>
                        <template v-if="ciclosEscolares.length" autocomplete="off">
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <div class="d-flex " style="justify-content: space-between;">
                    <label for="grupo" class="labelInput">
                        Grupo Administrativo
                    </label>
                    <div class="d-flex" v-if="gruposAdmin[0]">
                        <div> 
                            <vs-tooltip>
                                <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(gruposAdmin, 'grupos')"></i>
                                <template #tooltip>
                                    Seleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        <div class="labelInput">
                            <vs-tooltip>
                                <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('grupos')"></i>
                                <template #tooltip>
                                    Deseleccionar todo
                                </template>
                            </vs-tooltip>
                        </div>
                        
                    </div>
                </div>
                <div>
                    <vs-select 
                        :disabled="!gruposAdmin.length"
                        :loading="loadingGrupoAdmin"
                        filter
                        class="pt-0"
                        id="grupo"
                        placeholder="Seleccionar grupo administrativo"
                        :key="gruposAdminId"
                        v-model="grupoAdmin"
                        multiple
                        collapse-chips>
                        <template #message-danger v-if="errorFields.includes('grupoAdmin')">
                            Requerido
                        </template>
                        <template v-if="gruposAdmin.length">
                            <vs-option v-for="option in gruposAdmin" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </div>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col sm="12" lg="12" style="margin-top: 23px; display: flex">
                <vs-button
                    class="ml-auto"
                    @click="getDatosFiscales('online')"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
            <vs-col sm="12" lg="12" style="margin-top: 23px; display: flex">
                <vs-button
                    v-if="users != ''"
                    color="#55ce63"
                    relief
                    :loading="loadingExcel"
                    @click="getDatosFiscalesExcel('excel')"
                    class="ml-auto"
                >
                    <i class="fas fa-download mr-2"></i> Descargar reporte
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-alert v-if="mensaje">
            <template #title>
                No se encontro información.
            </template>
        </vs-alert>
        <vs-row v-if="estadisticas">
            <vs-col  v-if="estadisticas.datos_completos_cfdi4" sm="12" lg="4" class="p-1">
                <div class="card md-green">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{estadisticas.datos_completos_cfdi4}}</strong></h4>
                        <p class="mb-0"><strong>Datos completos</strong></p>
                    </div>
                </div>
            </vs-col>
            <vs-col  v-if="estadisticas.datos_incompletos_cfdi4" sm="12" lg="4" class="p-1">
                <div class="card md-red">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{estadisticas.datos_incompletos_cfdi4}}</strong></h4>
                        <p class="mb-0"><strong>Datos incompletos</strong></p>
                    </div>
                </div>
            </vs-col>
            <vs-col  v-if="estadisticas.facturacion_generica" sm="12" lg="4" class="p-1">
                <div class="card md-warn">
                    <div class="card-body text-center">
                        <h4 class="mb-0"><strong>{{estadisticas.facturacion_generica}}</strong></h4>
                        <p class="mb-0"><strong>Facturación genérica</strong></p>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <datos-fiscales :users="users"></datos-fiscales>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import DatosFiscales from './tabla-datos-fiscales.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            loadingInstituto: false,
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            loadingCiclo: false,
            grupoAdmin: '',
            gruposAdmin: [],
            gruposAdminId: (new Date()).getTime(),
            loadingGrupoAdmin: false,
            errorFields: [],
            users: [
            // {
            //     "no_lista": 1,
            //     "nombre": "NUÑO GARCIA GUILLERMO JAVIER",
            //     "matricula": "NGGU40",
            //     "grupo_administrativo": "12",
            //     "datos_fiscales": {
            //         "codigo_postal": "78214",
            //         "correo_fiscal": "albertobelmantellez@yahoo.com.mx",
            //         "facturacion_automatica": 1,
            //         "facturacion_manual": 0,
            //         "razon_social": "ALBERTO BELMAN TELLEZ",
            //         "regimen_fiscal": "605",
            //         "rfc": "BETA4805111B8",
            //         "uso_cfdi": "D10"
            //     }
            // },
            ],
            estadisticas: [],
            mensaje: false,
            loadingExcel: false
        }
    },
    components:{
        DatosFiscales
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'grupos'){
                this.grupoAdmin = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'grupos'){
                this.grupoAdmin = ''
            }
        },
        getClear(tipo){
            if(tipo == 'inst'){
                this.cicloEscolar = ''
                this.grupoAdmin =  ''
            }else if(tipo == 'ciclo'){
                this.grupoAdmin =  ''
            }
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await reportes.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        async getGrupoAdministrativo() {
            if(this.cicloEscolar){
                try {
                    const params = {
                        ciclo_escolar_id: this.cicloEscolar
                    }
                    this.loadingGrupoAdmin = true
                    const { data: response } = await reportes.getGrupo(this.institucion, params )
                    this.gruposAdmin = this.getEliminarNameKey(response)
                    this.gruposAdminId = (new Date()).getTime()
                    this.loadingGrupoAdmin = false
                }
                catch{

                }
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        sanityForm () {
            this.errorFields = []
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.grupoAdmin) {
                this.errorFields.push('grupoAdmin')
            }
            if (!this.errorFields.length){
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                }
                 if(this.grupoAdmin[0] == ''){
                    const eliminarGrupo = this.grupoAdmin.shift()
                    params.grupo_id = this.grupoAdmin
                }else{
                    params.grupo_id = this.grupoAdmin
                }
                return params
            } else {
                return null
            }
        },
        async getDatosFiscales(tipo){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                params.type_response = tipo
                try {
                    const { data: response } = await reportes.getDatosFiscales(params)
                    this.users = this.getEliminarNameKey(response.data)
                    this.estadisticas = response.estadisticas
                    loading.close()
                    if(tipo == 'excel'){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'success',
                            position: 'bottom-right',
                            title: 'Éxito',
                            text: 'Descarga lista'
                        })
                    }
                }
                catch(error){
                    loading.close()
                    if(tipo == 'excel'){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'ALgo salio mal',
                        })
                    }
                }
            }
        },
        async getDatosFiscalesExcel(tipo){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                params.type_response = tipo
                try {
                    const response = await reportes.getDatosFiscales(params)
                     if(response){
                    window.location.href = response.request.responseURL;
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    loading.close()
                }
                }
                catch(error){
                    loading.close()
                    if(tipo == 'excel'){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'ALgo salio mal',
                        })
                    }
                }
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
    },
    watch: {
        institucion(){
            this.getCicloEscolar()
        },
        cicloEscolar(){
            this.getGrupoAdministrativo()
        },
    }
}
</script>

<style lang="scss" scoped>
    
    .md-warn{
        background: #ffbc34;
        color: white;
        border-radius: 7px;
    }

    .md-red{
        background: #E74C3C;
        color: white;
        border-radius: 7px;
    }

    .md-green{
        background: #52BE80;
        color: white;
        border-radius: 7px;
    }
    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }

</style>